import { render, staticRenderFns } from "./UmkChart.vue?vue&type=template&id=95bfcfaa&scoped=true&"
import script from "./UmkChart.vue?vue&type=script&lang=js&"
export * from "./UmkChart.vue?vue&type=script&lang=js&"
import style0 from "./UmkChart.vue?vue&type=style&index=0&id=95bfcfaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bfcfaa",
  null
  
)

export default component.exports